__turbopack_context__.v({
  "graph": "DonationsChart-module-scss-module__k3VgPW__graph",
});
